export function formatNumber(value) {
  return value.toLocaleString('fr-FR');
}

export function calculateSavings(residenceCount) {
  const travelHours = 2 * residenceCount;
  const calls = 12 * residenceCount;
  const emails = 32 * residenceCount;
  const workWeeks = Math.floor(travelHours / 40);

  return {
    travelHours,
    calls,
    emails,
    workWeeks,
    formattedTravelHours: formatNumber(travelHours),
    formattedCalls: formatNumber(calls),
    formattedEmails: formatNumber(emails),
  };
}
